export enum EstimateDragItemTypes {
    Category = 'category',
    Measurement = 'measurement',
}
